export default "__VITE_ASSET__3452c20a__"